import { render } from "./CetaMargeCrop.vue?vue&type=template&id=6a8cda02&scoped=true&ts=true"
import script from "./CetaMargeCrop.vue?vue&type=script&lang=ts"
export * from "./CetaMargeCrop.vue?vue&type=script&lang=ts"

import "./CetaMargeCrop.vue?vue&type=style&index=0&id=6a8cda02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8cda02"]])

export default __exports__